/**
 * openHelpAgent — open (or focus) the Sam Help Agent popup window.
 *
 * Context tracking uses the server (sam-dbam) as the communication channel:
 *   - Each app POSTs its context to /dbam/v1/help/context on tab focus
 *   - The popup polls GET /dbam/v1/help/context/{userId} every 3 seconds
 *   - No cross-origin browser tricks needed
 */

let _helpPopup = null;

function getHelpAppUrl() {
    const isLocal = window.location.hostname === 'localhost'
        || window.location.hostname === '127.0.0.1';
    return isLocal
        ? 'http://localhost:3004'
        : 'https://help.samsurveyor.com';
}

function getDbamUrl() {
    const isLocal = window.location.hostname === 'localhost'
        || window.location.hostname === '127.0.0.1';
    return isLocal
        ? 'http://localhost:8080'
        : 'https://api.samsurveyor.com';
}

/**
 * Open (or focus) the help agent popup and set the context server-side.
 */
export function openHelpAgent({ context, userId } = {}) {
    const helpUrl = getHelpAppUrl();

    // Open or reuse the popup
    const params = new URLSearchParams();
    if (userId) params.set('userId', userId);
    if (context) params.set('context', context);
    _helpPopup = window.open(
        `${helpUrl}/?${params.toString()}`,
        'sam-help-agent',
        'width=520,height=760,resizable=yes,scrollbars=yes'
    );
    if (_helpPopup) {
        try { _helpPopup.focus(); } catch (_) { }
    }

    // Tell the server what context we're in
    if (context) {
        notifyHelpAgent(context, userId);
    }
}

/**
 * Notify the server of the user's current app context.
 * Called on tab focus by each app (Console/Designer/Explorer).
 * The popup polls the server to read this.
 */
export function notifyHelpAgent(context, userId) {
    const dbamUrl = getDbamUrl();
    fetch(`${dbamUrl}/dbam/v1/help/context`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            userId: userId || 'default',
            context: context,
        }),
    }).catch(() => {
        // Silent — context tracking is best-effort
    });
}
